import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndo } from '@fortawesome/free-solid-svg-icons';
import { useRolePresets } from '../../../hooks/useRolePresets';

export function UsersFilters({ filters, onChange, onSearch, onReset }) {
    // Los roles se crean desde la pestaña Roles y viven en role_presets: la lista
    // no puede estar fija en el cliente o los roles nuevos no aparecerian.
    const { presets: roles, error: rolesError } = useRolePresets();

    return (
        <div className="filters-panel">
            <div className="row g-3 align-items-end">
                <div className="col">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Buscar</label>
                    <input
                        type="text"
                        className="form-control bg-dark text-white border-secondary py-2"
                        value={filters.search || ''}
                        placeholder="Busca por username, nombre, apellido, email o cuenta..."
                        onChange={(e) => onChange('search', e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') onSearch(); }}
                    />
                </div>
                <div className="col">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Rol</label>
                    <select
                        className=" form-control form-select bg-dark text-white border-secondary py-2"
                        value={filters.role || ''}
                        onChange={(e) => onChange('role', e.target.value)}
                    >
                        <option value="">Todos</option>
                        {roles.map((role) => (
                            <option key={role.code} value={role.code}>{role.name}</option>
                        ))}
                    </select>
                    {rolesError && <small className="text-danger d-block mt-1">{rolesError}</small>}
                </div>
                <div className="col-auto d-flex gap-2">
                    <button className="btn btn-ink-search" onClick={onSearch}>
                        <FontAwesomeIcon icon={faSearch} className="me-1" /> Buscar
                    </button>
                    <button className="btn btn-outline-secondary border-secondary text-white-50 px-3" onClick={onReset}>
                        <FontAwesomeIcon icon={faUndo} className="me-1" /> Limpiar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UsersFilters;